export default class Usuario {
    id: number | null;
    username: string | null;
    password: string | null;
    ativo: boolean | null;
    nome: string | null;
}
